import { Node_Type as Node_Type$1 } from 'ricos-types';
import React, { Component, useContext } from 'react';
import { RicosViewerContext } from 'ricos-context';
import ReactDOM from 'react-dom';
import { isSSR } from 'wix-rich-content-common';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';
import { Node_Type } from 'ricos-schema';

const DEFAULTS = {
  config: {
    toolbar: {
      hidden: []
    }
  },
  configViewer: {
    getVideoUrl: (src) => `https://video.wixstatic.com/${src.pathname}`
  }
};

const VIDEO_TYPE = "wix-draft-plugin-video";

var styles = {"video_player":"DAcNU","videoOverlay":"-yaII","video_container":"XOa6C"};

var util = {};

util.getQueryParams = function getQueryParams(qs) {
  if (typeof qs !== 'string') {
    return {};
  }
  qs = qs.split('+').join(' ');

  var params = {};
  var match = qs.match(
    /(?:[?](?:[^=]+)=(?:[^&#]*)(?:[&](?:[^=]+)=(?:[^&#]*))*(?:[#].*)?)|(?:[#].*)/
  );
  var split;

  if (match === null) {
    return {};
  }

  split = match[0].substr(1).split(/[&#=]/);

  for (var i = 0; i < split.length; i += 2) {
    params[decodeURIComponent(split[i])] =
      decodeURIComponent(split[i + 1] || '');
  }

  return params;
};

util.combineParams = function combineParams(params, hasParams) {
  if (typeof params !== 'object') {
    return '';
  }
  var combined = '';
  var i = 0;
  var keys = Object.keys(params);

  if (keys.length === 0) {
    return '';
  }

  //always have parameters in the same order
  keys.sort();

  if (!hasParams) {
    combined += '?' + keys[0] + '=' + params[keys[0]];
    i += 1;
  }

  for (; i < keys.length; i += 1) {
    combined += '&' + keys[i] + '=' + params[keys[i]];
  }
  return combined;
};

//parses strings like 1h30m20s to seconds
function getLetterTime(timeString) {
  var totalSeconds = 0;
  var timeValues = {
    's': 1,
    'm': 1 * 60,
    'h': 1 * 60 * 60,
    'd': 1 * 60 * 60 * 24,
    'w': 1 * 60 * 60 * 24 * 7,
  };
  var timePairs;

  //expand to "1 h 30 m 20 s" and split
  timeString = timeString.replace(/([smhdw])/g, ' $1 ').trim();
  timePairs = timeString.split(' ');

  for (var i = 0; i < timePairs.length; i += 2) {
    totalSeconds += parseInt(timePairs[i], 10) *
      timeValues[timePairs[i + 1] || 's'];
  }
  return totalSeconds;
}

//parses strings like 1:30:20 to seconds
function getColonTime(timeString) {
  var totalSeconds = 0;
  var timeValues = [
    1,
    1 * 60,
    1 * 60 * 60,
    1 * 60 * 60 * 24,
    1 * 60 * 60 * 24 * 7,
  ];
  var timePairs = timeString.split(':');
  for (var i = 0; i < timePairs.length; i++) {
    totalSeconds += parseInt(timePairs[i], 10) * timeValues[timePairs.length - i - 1];
  }
  return totalSeconds;
}

util.getTime = function getTime(timeString) {
  if (typeof timeString === 'undefined') {
    return 0;
  }
  if (timeString.match(/^(\d+[smhdw]?)+$/)) {
    return getLetterTime(timeString);
  }
  if (timeString.match(/^(\d+:?)+$/)) {
    return getColonTime(timeString);
  }
  return 0;
};

const {
  getQueryParams,
} = util;

function UrlParser$1() {
  for (const key of [
    'parseProvider',
    'parse',
    'bind',
    'create',
  ]) {
    this[key] = this[key].bind(this);
  }
  this.plugins = {};
}

var urlParser = UrlParser$1;

UrlParser$1.prototype.parseProvider = function(url) {
  var match = url.match(
    /(?:(?:https?:)?\/\/)?(?:[^.]+\.)?(\w+)\./i
  );
  return match ? match[1] : undefined;
};

UrlParser$1.prototype.parse = function(url) {
  if (typeof url === 'undefined') {
    return undefined;
  }
  var provider = this.parseProvider(url);
  var result;
  var plugin = this.plugins[provider];
  if (!provider || !plugin || !plugin.parse) {
    return undefined;
  }
  result = plugin.parse.call(
    plugin, url, getQueryParams(url)
  );
  if (result) {
    result = removeEmptyParameters(result);
    result.provider = plugin.provider;
  }
  return result;
};

UrlParser$1.prototype.bind = function(plugin) {
  this.plugins[plugin.provider] = plugin;
  if (plugin.alternatives) {
    for (var i = 0; i < plugin.alternatives.length; i += 1) {
      this.plugins[plugin.alternatives[i]] = plugin;
    }
  }
};

UrlParser$1.prototype.create = function(op) {
  if (typeof (op) !== 'object' || typeof (op.videoInfo) !== 'object') {
    return undefined;
  }

  var vi = op.videoInfo;
  var params = op.params;
  var plugin = this.plugins[vi.provider];

  params = (params === 'internal') ? vi.params : params || {};

  if (plugin) {
    op.format = op.format || plugin.defaultFormat;
    // eslint-disable-next-line no-prototype-builtins
    if (plugin.formats.hasOwnProperty(op.format)) {
      return plugin.formats[op.format].apply(plugin, [vi, Object.assign({}, params)]);
    }
  }
  return undefined;
};

function removeEmptyParameters(result) {
  if (result.params && Object.keys(result.params).length === 0) {
    delete result.params;
  }
  return result;
}

const UrlParser = urlParser;
const parser$1 = new UrlParser();
var base = parser$1;

function Allocine() {
  this.provider = 'allocine';
  this.alternatives = [];
  this.defaultFormat = 'embed';
  this.formats = {
    embed: this.createEmbedUrl,
  };
  this.mediaTypes = {
    VIDEO: 'video',
  };
}

Allocine.prototype.parseUrl = function(url) {
  var match = url.match(/(?:\/video\/player_gen_cmedia=)([A-Za-z0-9]+)/i);
  return match ? match[1] : undefined;
};

Allocine.prototype.parse = function(url) {
  var result = {
    mediaType: this.mediaTypes.VIDEO,
    id: this.parseUrl(url),
  };
  return result.id ? result : undefined;
};

Allocine.prototype.createEmbedUrl = function(vi) {
  if (!vi.id || vi.mediaType !== this.mediaTypes.VIDEO) {
    return undefined;
  }

  return 'https://player.allocine.fr/' +  vi.id + '.html';
};

base.bind(new Allocine());

const { combineParams: combineParams$d } = util;

function CanalPlus() {
  this.provider = 'canalplus';
  this.defaultFormat = 'embed';
  this.formats = {
    embed: this.createEmbedUrl,
  };
  this.mediaTypes = {
    VIDEO: 'video',
  };
}

CanalPlus.prototype.parseParameters = function(params) {
  delete params.vid;
  return params;
};

CanalPlus.prototype.parse = function(url, params) {
  var _this = this;
  var result = {
    mediaType: this.mediaTypes.VIDEO,
    id: params.vid,
  };
  result.params = _this.parseParameters(params);

  if (!result.id) {
    return undefined;
  }
  return result;
};

CanalPlus.prototype.createEmbedUrl = function(vi, params) {
  if (!vi.id || vi.mediaType !== this.mediaTypes.VIDEO) {
    return undefined;
  }
  var url = 'http://player.canalplus.fr/embed/';
  params.vid = vi.id;

  url += combineParams$d(params);
  return url;
};

base.bind(new CanalPlus());

const { combineParams: combineParams$c } = util;

function Coub() {
  this.provider = 'coub';
  this.defaultFormat = 'long';
  this.formats = {
    long: this.createLongUrl,
    embed: this.createEmbedUrl,
  };
  this.mediaTypes = {
    VIDEO: 'video',
  };
}

Coub.prototype.parseUrl = function(url) {
  var match = url.match(
    /(?:embed|view)\/([a-zA-Z\d]+)/i
  );
  return match ? match[1] : undefined;
};

Coub.prototype.parse = function(url, params) {
  var result = {
    mediaType: this.mediaTypes.VIDEO,
    params: params,
    id: this.parseUrl(url),
  };

  if (!result.id) {
    return undefined;
  }
  return result;
};

Coub.prototype.createUrl = function(baseUrl, vi, params) {
  if (!vi.id || vi.mediaType !== this.mediaTypes.VIDEO) {
    return undefined;
  }
  var url = baseUrl + vi.id;
  url += combineParams$c(params);
  return url;
};

Coub.prototype.createLongUrl = function(vi, params) {
  return this.createUrl('https://coub.com/view/', vi, params);
};

Coub.prototype.createEmbedUrl = function(vi, params) {
  return this.createUrl('//coub.com/embed/', vi, params);
};

base.bind(new Coub());

const { combineParams: combineParams$b, getTime: getTime$5 } = util;

function Dailymotion() {
  this.provider = 'dailymotion';
  this.alternatives = ['dai'];
  this.defaultFormat = 'long';
  this.formats = {
    short: this.createShortUrl,
    long: this.createLongUrl,
    embed: this.createEmbedUrl,
    image: this.createImageUrl,
  };
  this.mediaTypes = {
    VIDEO: 'video',
  };
}

Dailymotion.prototype.parseParameters = function(params) {
  return this.parseTime(params);
};

Dailymotion.prototype.parseTime = function(params) {
  if (params.start) {
    params.start = getTime$5(params.start);
  }
  return params;
};

Dailymotion.prototype.parseUrl = function(url) {
  var match = url.match(/(?:\/video|ly)\/([A-Za-z0-9]+)/i);
  return match ? match[1] : undefined;
};

Dailymotion.prototype.parse = function(url, params) {
  var _this = this;
  var result = {
    mediaType: this.mediaTypes.VIDEO,
    params: _this.parseParameters(params),
    id: _this.parseUrl(url),
  };
  return result.id ? result : undefined;
};

Dailymotion.prototype.createUrl = function(base, vi, params) {
  if (!vi.id || vi.mediaType !== this.mediaTypes.VIDEO) {
    return undefined;
  }
  return base + vi.id + combineParams$b(params);
};

Dailymotion.prototype.createShortUrl = function(vi, params) {
  return this.createUrl('https://dai.ly/', vi, params);
};

Dailymotion.prototype.createLongUrl = function(vi, params) {
  return this.createUrl('https://dailymotion.com/video/', vi, params);
};

Dailymotion.prototype.createEmbedUrl = function(vi, params) {
  return this.createUrl('https://www.dailymotion.com/embed/video/', vi, params);
};

Dailymotion.prototype.createImageUrl = function(vi, params) {
  delete params.start;
  return this.createUrl('https://www.dailymotion.com/thumbnail/video/', vi, params);
};

base.bind(new Dailymotion());

const { combineParams: combineParams$a } = util;

function Loom() {
  this.provider = 'loom';
  this.defaultFormat = 'long';
  this.formats = {
    long: this.createLongUrl,
    embed: this.createEmbedUrl,
  };
  this.mediaTypes = {
    VIDEO: 'video',
  };
}

Loom.prototype.parseUrl = function(url) {
  var match = url.match(
    /(?:share|embed)\/([a-zA-Z\d]+)/i
  );
  return match ? match[1] : undefined;
};

Loom.prototype.parse = function(url, params) {
  var result = {
    mediaType: this.mediaTypes.VIDEO,
    params: params,
    id: this.parseUrl(url),
  };
  return result.id ? result : undefined;
};

Loom.prototype.createUrl = function(baseUrl, vi, params) {
  if (!vi.id || vi.mediaType !== this.mediaTypes.VIDEO) {
    return undefined;
  }

  var url = baseUrl + vi.id;
  url += combineParams$a(params);
  return url;
};

Loom.prototype.createLongUrl = function(vi, params) {
  return this.createUrl('https://loom.com/share/', vi, params);
};

Loom.prototype.createEmbedUrl = function(vi, params) {
  return this.createUrl('//loom.com/embed/', vi, params);
};

base.bind(new Loom());

const {
  combineParams: combineParams$9,
  getTime: getTime$4,
} = util;

function Twitch() {
  this.provider = 'twitch';
  this.defaultFormat = 'long';
  this.formats = {
    long: this.createLongUrl,
    embed: this.createEmbedUrl,
  };
  this.mediaTypes = {
    VIDEO: 'video',
    STREAM: 'stream',
    CLIP: 'clip',
  };
}

Twitch.prototype.seperateId = function(id) {
  return {
    pre: id[0],
    id: id.substr(1),
  };
};

Twitch.prototype.parseChannel = function(result, params) {
  var channel = params.channel || params.utm_content || result.channel;
  delete params.utm_content;
  delete params.channel;
  return channel;
};

Twitch.prototype.parseUrl = function(url, result, params) {
  var match;
  match = url.match(
    /(clips\.)?twitch\.tv\/(?:(?:videos\/(\d+))|(\w+(?:-[\w\d-]+)?)(?:\/clip\/(\w+))?)/i
  );

  if (match && match[2]) { //video
    result.id = 'v' + match[2];
  } else if (params.video) { //video embed
    result.id = params.video;
    delete params.video;
  } else if (params.clip) { //clips embed
    result.id = params.clip;
    result.isClip = true;
    delete params.clip;
  } else if (match && match[1] && match[3]) { //clips.twitch.tv/id
    result.id = match[3];
    result.isClip = true;
  } else if (match && match[3] && match[4]) { //twitch.tv/channel/clip/id
    result.channel = match[3];
    result.id = match[4];
    result.isClip = true;
  } else if (match && match[3]) {
    result.channel = match[3];
  }
  return result;
};

Twitch.prototype.parseMediaType = function(result) {
  var mediaType;
  if (result.id) {
    if (result.isClip) {
      mediaType = this.mediaTypes.CLIP;
      delete result.isClip;
    } else {
      mediaType = this.mediaTypes.VIDEO;
    }
  } else if (result.channel) {
    mediaType = this.mediaTypes.STREAM;
  }
  return mediaType;
};

Twitch.prototype.parseParameters = function(params) {
  if (params.t) {
    params.start = getTime$4(params.t);
    delete params.t;
  }
  return params;
};

Twitch.prototype.parse = function(url, params) {
  var _this = this;
  var result = {};
  result = _this.parseUrl(url, result, params);
  result.channel = _this.parseChannel(result, params);
  result.mediaType = _this.parseMediaType(result);
  result.params = _this.parseParameters(params);
  return result.channel || result.id ? result : undefined;
};

Twitch.prototype.createLongUrl = function(vi, params) {
  var url = '';

  if (vi.mediaType === this.mediaTypes.STREAM && vi.channel) {
    url = 'https://twitch.tv/' + vi.channel;
  }
  else if (vi.mediaType === this.mediaTypes.VIDEO && vi.id) {
    var sep = this.seperateId(vi.id);
    url = 'https://twitch.tv/videos/' + sep.id;
    if (params.start) {
      params.t = params.start + 's';
      delete params.start;
    }
  }
  else if (vi.mediaType === this.mediaTypes.CLIP && vi.id) {
    if (vi.channel) {
      url = 'https://www.twitch.tv/' + vi.channel + '/clip/' + vi.id;
    } else {
      url = 'https://clips.twitch.tv/' + vi.id;
    }
  } else {
    return undefined;
  }
  url += combineParams$9(params);

  return url;
};

Twitch.prototype.createEmbedUrl = function(vi, params) {
  var url = 'https://player.twitch.tv/';

  if (vi.mediaType === this.mediaTypes.STREAM && vi.channel) {
    params.channel = vi.channel;
  }
  else if (vi.mediaType === this.mediaTypes.VIDEO && vi.id) {
    params.video = vi.id;
    if (params.start) {
      params.t = params.start + 's';
      delete params.start;
    }
  }
  else if (vi.mediaType === this.mediaTypes.CLIP && vi.id) {
    url = 'https://clips.twitch.tv/embed';
    params.clip = vi.id;
  } else {
    return undefined;
  }

  url += combineParams$9(params);

  return url;
};

base.bind(new Twitch());

const { combineParams: combineParams$8, getTime: getTime$3 } = util;

function Vimeo() {
  this.provider = 'vimeo';
  this.alternatives = ['vimeopro'];
  this.defaultFormat = 'long';
  this.formats = {
    long: this.createLongUrl,
    embed: this.createEmbedUrl,
  };
  this.mediaTypes = {
    VIDEO: 'video',
  };
}

Vimeo.prototype.parseUrl = function(url) {
  var match = url.match(
    /(?:\/showcase\/\d+)?(?:\/(?:channels\/[\w]+|(?:(?:album\/\d+|groups\/[\w]+)\/)?videos?))?\/(\d+)/i
  );
  return match ? match[1] : undefined;
};

Vimeo.prototype.parseHash = function(url) {
  var match = url.match(/\/\d+\/(\w+)$/i);
  return match ? match[1] : undefined;
};

Vimeo.prototype.parseParameters = function(params) {
  if (params.t) {
    params.start = getTime$3(params.t);
    delete params.t;
  }
  if (params.h) {
    params.hash = params.h;
    delete params.h;
  }
  return params;
};

Vimeo.prototype.parse = function(url, params) {
  var result = {
    mediaType: this.mediaTypes.VIDEO,
    params: this.parseParameters(params),
    id: this.parseUrl(url),
  };
  var hash = this.parseHash(url, params);
  if (hash) {
    result.params.hash = hash;
  }
  return result.id ? result : undefined;
};

Vimeo.prototype.createUrl = function(baseUrl, vi, params, type) {
  if (!vi.id || vi.mediaType !== this.mediaTypes.VIDEO) {
    return undefined;
  }

  var url = baseUrl + vi.id;
  var startTime = params.start;
  delete params.start;

  if (params.hash) {
    if (type === 'embed') {
      params.h = params.hash;
    } else if (type === 'long') {
      url += '/' + params.hash;
    }
    delete params.hash;
  }

  url += combineParams$8(params);

  if (startTime) {
    url += '#t=' + startTime;
  }
  return url;
};

Vimeo.prototype.createLongUrl = function(vi, params) {
  return this.createUrl('https://vimeo.com/', vi, params, 'long');
};

Vimeo.prototype.createEmbedUrl = function(vi, params) {
  return this.createUrl('//player.vimeo.com/video/', vi, params, 'embed');
};

base.bind(new Vimeo());

const {
  combineParams: combineParams$7,
  getTime: getTime$2,
} = util;

function Wistia() {
  this.provider = 'wistia';
  this.alternatives = [];
  this.defaultFormat = 'long';
  this.formats = {
    long: this.createLongUrl,
    embed: this.createEmbedUrl,
    embedjsonp: this.createEmbedJsonpUrl,
  };
  this.mediaTypes = {
    VIDEO: 'video',
    EMBEDVIDEO: 'embedvideo',
  };
}

Wistia.prototype.parseUrl = function(url) {
  var match = url.match(
    /(?:(?:medias|iframe)\/|wvideo=)([\w-]+)/
  );
  return match ? match[1] : undefined;
};

Wistia.prototype.parseChannel = function(url) {
  var match = url.match(
    /(?:(?:https?:)?\/\/)?([^.]*)\.wistia\./
  );
  var channel = match ? match[1] : undefined;
  if (channel === 'fast' || channel === 'content') {
    return undefined;
  }
  return channel;
};

Wistia.prototype.parseParameters = function(params, result) {
  if (params.wtime) {
    params.start = getTime$2(params.wtime);
    delete params.wtime;
  }
  if (params.wvideo === result.id) {
    delete params.wvideo;
  }
  return params;
};

Wistia.prototype.parseMediaType = function(result) {
  if (result.id && result.channel) {
    return this.mediaTypes.VIDEO;
  } else if (result.id) {
    delete result.channel;
    return this.mediaTypes.EMBEDVIDEO;
  } else {
    return undefined;
  }
};

Wistia.prototype.parse = function(url, params) {
  var result = {
    id: this.parseUrl(url),
    channel: this.parseChannel(url),
  };
  result.params = this.parseParameters(params, result);
  result.mediaType = this.parseMediaType(result);

  if (!result.id) {
    return undefined;
  }

  return result;
};

Wistia.prototype.createUrl = function(vi, params, url) {
  if (params.start) {
    params.wtime = params.start;
    delete params.start;
  }

  url += combineParams$7(params);

  return url;
};

Wistia.prototype.createLongUrl = function(vi, params) {
  if (!vi.id || vi.mediaType !== this.mediaTypes.VIDEO) {
    return undefined;
  }
  var url = 'https://' + vi.channel + '.wistia.com/medias/' + vi.id;
  return this.createUrl(vi, params, url);
};

Wistia.prototype.createEmbedUrl = function(vi, params) {
  if (!vi.id || !(vi.mediaType === this.mediaTypes.VIDEO || vi.mediaType === this.mediaTypes.EMBEDVIDEO)) {
    return undefined;
  }
  var url = 'https://fast.wistia.com/embed/iframe/' + vi.id;
  return this.createUrl(vi, params, url);
};

Wistia.prototype.createEmbedJsonpUrl = function(vi) {
  if (!vi.id || !(vi.mediaType === this.mediaTypes.VIDEO || vi.mediaType === this.mediaTypes.EMBEDVIDEO)) {
    return undefined;
  }
  return 'https://fast.wistia.com/embed/medias/' + vi.id + '.jsonp';
};

base.bind(new Wistia());

const {combineParams: combineParams$6} = util;

function Youku() {
  this.provider = 'youku';
  this.defaultFormat = 'long';
  this.formats = {
    embed: this.createEmbedUrl,
    long: this.createLongUrl,
    flash: this.createFlashUrl,
    static: this.createStaticUrl,
  };
  this.mediaTypes = {
    VIDEO: 'video',
  };
}

Youku.prototype.parseUrl = function(url) {
  var match = url.match(
    /(?:(?:embed|sid)\/|v_show\/id_|VideoIDS=)([a-zA-Z0-9]+)/
  );
  return match ? match[1] : undefined;
};

Youku.prototype.parseParameters = function(params) {
  if (params.VideoIDS) {
    delete params.VideoIDS;
  }
  return params;
};

Youku.prototype.parse = function(url, params) {
  var _this = this;
  var result = {
    mediaType: this.mediaTypes.VIDEO,
    id: _this.parseUrl(url),
    params: _this.parseParameters(params),
  };

  if (!result.id) {
    return undefined;
  }
  return result;
};

Youku.prototype.createUrl = function(baseUrl, vi, params) {
  if (!vi.id || vi.mediaType !== this.mediaTypes.VIDEO) {
    return undefined;
  }
  var url = baseUrl + vi.id;

  url += combineParams$6(params);
  return url;
};


Youku.prototype.createEmbedUrl = function(vi, params) {
  return this.createUrl('http://player.youku.com/embed/', vi, params);
};

Youku.prototype.createLongUrl = function(vi, params) {
  return this.createUrl('http://v.youku.com/v_show/id_', vi, params);
};

Youku.prototype.createStaticUrl = function(vi, params) {
  return this.createUrl(
    'http://static.youku.com/v1.0.0638/v/swf/loader.swf?VideoIDS=',
    vi, params
  );
};

Youku.prototype.createFlashUrl = function(vi, params) {
  if (!vi.id || vi.mediaType !== this.mediaTypes.VIDEO) {
    return undefined;
  }
  var url = 'http://player.youku.com/player.php/sid/' + vi.id + '/v.swf';

  url += combineParams$6(params);
  return url;
};

base.bind(new Youku());

const {
  combineParams: combineParams$5,
  getTime: getTime$1,
} = util;

function YouTube() {
  this.provider = 'youtube';
  this.alternatives = ['youtu', 'ytimg'];
  this.defaultFormat = 'long';
  this.formats = {
    short: this.createShortUrl,
    long: this.createLongUrl,
    embed: this.createEmbedUrl,
    shortImage: this.createShortImageUrl,
    longImage: this.createLongImageUrl,
  };
  this.imageQualities = {
    '0': '0',
    '1': '1',
    '2': '2',
    '3': '3',
    DEFAULT: 'default',
    HQDEFAULT: 'hqdefault',
    SDDEFAULT: 'sddefault',
    MQDEFAULT: 'mqdefault',
    MAXRESDEFAULT: 'maxresdefault',
  };
  this.defaultImageQuality = this.imageQualities.HQDEFAULT;
  this.mediaTypes = {
    VIDEO: 'video',
    PLAYLIST: 'playlist',
    SHARE: 'share',
    CHANNEL: 'channel',
  };
}

YouTube.prototype.parseVideoUrl = function(url) {
  var match = url.match(
    /(?:(?:v|vi|be|videos|embed)\/(?!videoseries)|(?:v|ci)=)([\w-]{11})/i
  );
  return match ? match[1] : undefined;
};

YouTube.prototype.parseChannelUrl = function(url) {
  // Match an opaque channel ID
  var match = url.match(/\/channel\/([\w-]+)/);
  if (match) {
    return { id: match[1], mediaType: this.mediaTypes.CHANNEL };
  }

  // Match a vanity channel name or a user name. User urls are deprecated and
  // currently redirect to the channel of that same name.
  match = url.match(/\/(?:c|user)\/([\w-]+)/);
  if (match) {
    return { name: match[1], mediaType: this.mediaTypes.CHANNEL };
  }
};

YouTube.prototype.parseParameters = function(params, result) {
  if (params.start || params.t) {
    params.start = getTime$1(params.start || params.t);
    delete params.t;
  }
  if (params.v === result.id) {
    delete params.v;
  }
  if (params.list === result.id) {
    delete params.list;
  }

  return params;
};

YouTube.prototype.parseMediaType = function(result) {
  if (result.params.list) {
    result.list = result.params.list;
    delete result.params.list;
  }
  if (result.id && !result.params.ci) {
    result.mediaType = this.mediaTypes.VIDEO;
  } else if (result.list) {
    delete result.id;
    result.mediaType = this.mediaTypes.PLAYLIST;
  } else if (result.params.ci) {
    delete result.params.ci;
    result.mediaType = this.mediaTypes.SHARE;
  } else {
    return undefined;
  }
  return result;
};

YouTube.prototype.parse = function(url, params) {
  var channelResult = this.parseChannelUrl(url);
  if (channelResult) {
    return channelResult;
  } else {
    var result = {
      params: params,
      id: this.parseVideoUrl(url),
    };
    result.params = this.parseParameters(params, result);
    result = this.parseMediaType(result);
    return result;
  }
};

YouTube.prototype.createShortUrl = function(vi, params) {
  if (!vi.id || vi.mediaType !== this.mediaTypes.VIDEO) {
    return undefined;
  }

  var url = 'https://youtu.be/' + vi.id;
  if (params.start) {
    url += '#t=' + params.start;
  }
  return url;
};

YouTube.prototype.createLongUrl = function(vi, params) {
  var url = '';
  var startTime = params.start;
  delete params.start;

  if (vi.mediaType === this.mediaTypes.CHANNEL) {
    if (vi.id) {
      url += 'https://www.youtube.com/channel/' + vi.id;
    } else if (vi.name) {
      url += 'https://www.youtube.com/c/' + vi.name;
    } else {
      return undefined;
    }
  }
  else if (vi.mediaType === this.mediaTypes.PLAYLIST && vi.list) {
    params.feature = 'share';
    url += 'https://www.youtube.com/playlist';
  }
  else if (vi.mediaType === this.mediaTypes.VIDEO && vi.id) {
    params.v = vi.id;
    url += 'https://www.youtube.com/watch';
  }
  else if (vi.mediaType === this.mediaTypes.SHARE && vi.id) {
    params.ci = vi.id;
    url += 'https://www.youtube.com/shared';
  } else {
    return undefined;
  }

  if (vi.list) {
    params.list = vi.list;
  }

  url += combineParams$5(params);

  if (vi.mediaType !== this.mediaTypes.PLAYLIST && startTime) {
    url += '#t=' + startTime;
  }
  return url;
};

YouTube.prototype.createEmbedUrl = function(vi, params) {
  var url = 'https://www.youtube.com/embed';

  if (vi.mediaType === this.mediaTypes.PLAYLIST && vi.list) {
    params.listType = 'playlist';
  } else if (vi.mediaType === this.mediaTypes.VIDEO && vi.id) {
    url += '/' + vi.id;
    //loop hack
    if (params.loop === '1') {
      params.playlist = vi.id;
    }
  } else {
    return undefined;
  }

  if (vi.list) {
    params.list = vi.list;
  }

  url += combineParams$5(params);

  return url;
};

YouTube.prototype.createImageUrl = function(baseUrl, vi, params) {
  if (!vi.id || vi.mediaType !== this.mediaTypes.VIDEO) {
    return undefined;
  }
  var url = baseUrl + vi.id + '/';
  var quality = params.imageQuality || this.defaultImageQuality;

  return url + quality + '.jpg';
};

YouTube.prototype.createShortImageUrl = function(vi, params) {
  return this.createImageUrl('https://i.ytimg.com/vi/', vi, params);
};

YouTube.prototype.createLongImageUrl = function(vi, params) {
  return this.createImageUrl('https://img.youtube.com/vi/', vi, params);
};

base.bind(new YouTube());

const {
  combineParams: combineParams$4,
  getTime,
} = util;

function SoundCloud() {
  this.provider = 'soundcloud';
  this.defaultFormat = 'long';
  this.formats = {
    long: this.createLongUrl,
    embed: this.createEmbedUrl,
  };
  this.mediaTypes = {
    TRACK: 'track',
    PLAYLIST: 'playlist',
    APITRACK: 'apitrack',
    APIPLAYLIST: 'apiplaylist',
  };
}

SoundCloud.prototype.parseUrl = function(url, result) {
  var match = url.match(
    /(?:m\.)?soundcloud\.com\/(?:([\w-]+)\/(sets\/)?)([\w-]+)/i
  );
  if (!match) {
    return result;
  }
  result.channel = match[1];
  if (match[1] === 'playlists' || match[2]) { //playlist
    result.list = match[3];
  } else { //track
    result.id = match[3];
  }
  return result;
};

SoundCloud.prototype.parseParameters = function(params) {
  if (params.t) {
    params.start = getTime(params.t);
    delete params.t;
  }
  return params;
};

SoundCloud.prototype.parseMediaType = function(result) {
  if (result.id) {
    if (result.channel === 'tracks') {
      delete result.channel;
      delete result.params.url;
      result.mediaType = this.mediaTypes.APITRACK;
    } else {
      result.mediaType = this.mediaTypes.TRACK;
    }
  }
  if (result.list) {
    if (result.channel === 'playlists') {
      delete result.channel;
      delete result.params.url;
      result.mediaType = this.mediaTypes.APIPLAYLIST;
    } else {
      result.mediaType = this.mediaTypes.PLAYLIST;
    }
  }
  return result;
};

SoundCloud.prototype.parse = function(url, params) {
  var result = {};
  result = this.parseUrl(url, result);
  result.params = this.parseParameters(params);
  result = this.parseMediaType(result);
  if (!result.id && !result.list) {
    return undefined;
  }
  return result;
};

SoundCloud.prototype.createLongUrl = function(vi, params) {
  var url = '';
  var startTime = params.start;
  delete params.start;

  if (vi.mediaType === this.mediaTypes.TRACK && vi.id && vi.channel) {
    url = 'https://soundcloud.com/' + vi.channel + '/' + vi.id;
  }
  else if (vi.mediaType === this.mediaTypes.PLAYLIST && vi.list && vi.channel) {
    url = 'https://soundcloud.com/' + vi.channel + '/sets/' + vi.list;
  }
  else if (vi.mediaType === this.mediaTypes.APITRACK && vi.id) {
    url = 'https://api.soundcloud.com/tracks/' + vi.id;
  }
  else if (vi.mediaType === this.mediaTypes.APIPLAYLIST && vi.list) {
    url = 'https://api.soundcloud.com/playlists/' + vi.list;
  } else {
    return undefined;
  }

  url += combineParams$4(params);

  if (startTime) {
    url += '#t=' + startTime;
  }
  return url;
};

SoundCloud.prototype.createEmbedUrl = function(vi, params) {
  var url = 'https://w.soundcloud.com/player/';
  delete params.start;

  if (vi.mediaType === this.mediaTypes.APITRACK && vi.id) {
    params.url = 'https%3A//api.soundcloud.com/tracks/' + vi.id;
  }
  else if (vi.mediaType === this.mediaTypes.APIPLAYLIST && vi.list) {
    params.url = 'https%3A//api.soundcloud.com/playlists/' + vi.list;
  } else {
    return undefined;
  }

  url += combineParams$4(params);
  return url;
};

base.bind(new SoundCloud());

const {
  combineParams: combineParams$3,
} = util;

function TeacherTube() {
  this.provider = 'teachertube';
  this.alternatives = [];
  this.defaultFormat = 'long';
  this.formats = {
    long: this.createLongUrl,
    embed: this.createEmbedUrl,
  };
  this.mediaTypes = {
    VIDEO: 'video',
    AUDIO: 'audio',
    DOCUMENT: 'document',
    CHANNEL: 'channel',
    COLLECTION: 'collection',
    GROUP: 'group',
  };
}

TeacherTube.prototype.parse = function(url, params) {
  var result = {};

  result.list = this.parsePlaylist(params);
  result.params = params;

  var match = url.match(
    /\/(audio|video|document|user\/channel|collection|group)\/(?:[\w-]+-)?(\w+)/
  );

  if (!match) {
    return undefined;
  }
  result.mediaType = this.parseMediaType(match[1]);
  result.id = match[2];

  return result;
};

TeacherTube.prototype.parsePlaylist = function(params) {
  if (params['playlist-id']) {
    var list = params['playlist-id'];
    delete params['playlist-id'];
    return list;
  }
  return undefined;
};

TeacherTube.prototype.parseMediaType = function(mediaTypeMatch) {
  switch (mediaTypeMatch) {
  case 'audio':
    return this.mediaTypes.AUDIO;
  case 'video':
    return this.mediaTypes.VIDEO;
  case 'document':
    return this.mediaTypes.DOCUMENT;
  case 'user/channel':
    return this.mediaTypes.CHANNEL;
  case 'collection':
    return this.mediaTypes.COLLECTION;
  case 'group':
    return this.mediaTypes.GROUP;
  }
};

TeacherTube.prototype.createLongUrl = function(vi, params) {
  if (!vi.id) {
    return undefined;
  }
  var url = 'https://www.teachertube.com/';

  if (vi.list) {
    params['playlist-id'] = vi.list;
  }

  if (vi.mediaType === this.mediaTypes.CHANNEL) {
    url += 'user/channel/';
  } else {
    url += vi.mediaType + '/';
  }
  url += vi.id;

  url += combineParams$3(params);

  return url;
};

TeacherTube.prototype.createEmbedUrl = function(vi, params) {
  if (!vi.id) {
    return undefined;
  }

  var url = 'https://www.teachertube.com/embed/';

  if (vi.mediaType === this.mediaTypes.VIDEO || vi.mediaType === this.mediaTypes.AUDIO) {
    url += vi.mediaType + '/' + vi.id;
  } else {
    return undefined;
  }

  url += combineParams$3(params);

  return url;
};

base.bind(new TeacherTube());

const {
  combineParams: combineParams$2,
} = util;

function TikTok() {
  this.provider = 'tiktok';
  this.defaultFormat = 'long';
  this.formats = {
    long: this.createLongUrl,
  };
  this.mediaTypes = {
    VIDEO: 'video',
  };
}

TikTok.prototype.parse = function(url, params) {
  var result = {
    params: params,
    mediaType: this.mediaTypes.VIDEO,
  };

  var match = url.match(/@([^/]+)\/video\/(\d{19})/);

  if (!match) {
    return;
  }

  result.channel = match[1];
  result.id = match[2];

  return result;
};

TikTok.prototype.createLongUrl = function(vi, params) {
  var url = '';

  if (vi.mediaType === this.mediaTypes.VIDEO && vi.id && vi.channel) {
    url += `https://www.tiktok.com/@${vi.channel}/video/${vi.id}`;
  } else {
    return undefined;
  }

  url += combineParams$2(params);

  return url;
};

base.bind(new TikTok());

const { combineParams: combineParams$1 } = util;

function Ted() {
  this.provider = 'ted';
  this.formats = {
    long: this.createLongUrl,
    embed: this.createEmbedUrl,
  };
  this.mediaTypes = {
    VIDEO: 'video',
    PLAYLIST: 'playlist',
  };
}

Ted.prototype.parseUrl = function(url, result) {
  var match = url.match(/\/(talks|playlists\/(\d+))\/([\w-]+)/i);
  var channel = match ? match[1] : undefined;

  if (!channel) {
    return result;
  }

  result.channel = channel.split('/')[0];
  result.id = match[3];

  if (result.channel === 'playlists') {
    result.list = match[2];
  }

  return result;
};

Ted.prototype.parseMediaType = function(result) {
  if (result.id && result.channel === 'playlists') {
    delete result.channel;
    result.mediaType = this.mediaTypes.PLAYLIST;
  }
  if (result.id && result.channel === 'talks') {
    delete result.channel;
    result.mediaType = this.mediaTypes.VIDEO;
  }

  return result;
};

Ted.prototype.parse = function(url, params) {
  var result = {
    params: params,
  };

  result = this.parseUrl(url, result);
  result = this.parseMediaType(result);

  if (!result.id) {
    return undefined;
  }

  return result;
};

Ted.prototype.createLongUrl = function(vi, params) {
  var url = '';

  if (vi.mediaType === this.mediaTypes.VIDEO && vi.id) {
    url += 'https://ted.com/talks/' + vi.id;
  }
  else if (vi.mediaType === this.mediaTypes.PLAYLIST && vi.id) {
    url += 'https://ted.com/playlists/' + vi.list + '/' + vi.id;
  } else {
    return undefined;
  }

  url += combineParams$1(params);

  return url;
};

Ted.prototype.createEmbedUrl = function(vi, params) {
  var url = 'https://embed.ted.com/';

  if (vi.mediaType === this.mediaTypes.PLAYLIST && vi.id) {
    url += 'playlists/' + vi.list + '/' + vi.id;
  }
  else if (vi.mediaType === this.mediaTypes.VIDEO && vi.id) {
    url += 'talks/' + vi.id;
  } else {
    return undefined;
  }

  url += combineParams$1(params);
  return url;
};

base.bind(new Ted());

const {
  combineParams,
} = util;

function Facebook() {
  this.provider = 'facebook';
  this.alternatives = [];
  this.defaultFormat = 'long';
  this.formats = {
    long: this.createLongUrl,
    watch: this.createWatchUrl,
  };
  this.mediaTypes = {
    VIDEO: 'video',
  };
}

Facebook.prototype.parse = function(url, params) {
  var result = {
    params: params,
    mediaType: this.mediaTypes.VIDEO,
  };

  var match = url.match(/(?:\/(\d+))?\/videos(?:\/.*?)?\/(\d+)/i);
  if (match) {
    if (match[1]) {
      result.pageId = match[1];
    }
    result.id = match[2];
  }
  if (params.v && !result.id) {
    result.id = params.v;
    delete params.v;
    result.params = params;
  }

  if (!result.id) {
    return undefined;
  }

  return result;
};

Facebook.prototype.createWatchUrl = function(vi, params) {
  var url = 'https://facebook.com/watch/';

  if (vi.mediaType !== this.mediaTypes.VIDEO || !vi.id) {
    return undefined;
  }
  params = { v: vi.id };
  url += combineParams(params);

  return url;
};

Facebook.prototype.createLongUrl = function(vi, params) {
  var url = 'https://facebook.com/';

  if (vi.pageId) {
    url += vi.pageId;
  } else {
    return undefined;
  }

  if (vi.mediaType === this.mediaTypes.VIDEO && vi.id) {
    url += '/videos/' + vi.id;
  } else {
    return undefined;
  }

  url += combineParams(params);

  return url;
};

base.bind(new Facebook());

const parser = base;















var lib = parser;

const IframePlayer = ({ isCustomVideo, url }) => {
  const embedUrl = isCustomVideo ? url : lib.create({
    videoInfo: lib.parse(url),
    format: "embed"
  });
  return /* @__PURE__ */ React.createElement(
    "iframe",
    {
      "data-hook": "video-ssr-viewer",
      title: "ricos-video",
      style: { width: "100%" },
      allow: "fullscreen",
      src: embedUrl,
      allowFullScreen: true
    }
  );
};

({
  insertVideo: `${Node_Type.VIDEO}.insertVideo`,
  insertYoutube: `${Node_Type.VIDEO}.insertYoutube`,
  replace: `${Node_Type.VIDEO}.replace`,
  settings: `${Node_Type.VIDEO}.settings`
});
({
  alignment: `${Node_Type.VIDEO}.alignment`,
  size: `${Node_Type.VIDEO}.size`
});
const pauseTrigger = { scroll: "scroll" };

var __defProp$2 = Object.defineProperty;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp$2(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const VIMEO_SDK_URL = "https://player.vimeo.com/api/player.js";
const VIMEO_GLOBAL = "Vimeo";
class ReactPlayerWrapper extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "isVimeoAndRequireJS", () => !isSSR() && isVimeoUrl(this.props.url) && !window[VIMEO_GLOBAL] && window.requirejs);
    __publicField(this, "handleAutoPlay", () => {
      var _a;
      if (window == null ? void 0 : window.IntersectionObserver) {
        const intersectionObserver = new IntersectionObserver((entries) => {
          const { disabled } = this.props;
          entries.forEach((entry) => {
            const startAutoPlay = entry.isIntersecting && !disabled && !this.state.isAutoPlayPaused;
            if (startAutoPlay) {
              this.handlePlay();
            } else {
              this.handlePause(pauseTrigger.scroll);
            }
          });
        });
        const reactPlayerElement = (_a = this.playerRef) == null ? void 0 : _a.current.wrapper;
        intersectionObserver.observe(reactPlayerElement);
      }
    });
    __publicField(this, "handlePlay", () => {
      if (!this.state.isPlaying) {
        this.setState({ isPlaying: true });
      }
    });
    __publicField(this, "handlePause", (trigger) => {
      if (this.state.isPlaying) {
        const isAutoPlayPaused = trigger !== pauseTrigger.scroll;
        this.setState({ isPlaying: false, isAutoPlayPaused });
      }
    });
    __publicField(this, "onWrapperClick", () => {
      if (this.props.isCustomVideo && !this.props.controls) {
        this.state.isPlaying ? this.handlePause() : this.handlePlay();
      }
    });
    this.playerRef = React.createRef();
    this.state = {
      vimeoLoaded: false,
      isPlaying: false,
      isAutoPlayPaused: false
    };
  }
  componentDidMount() {
    if (this.isVimeoAndRequireJS()) {
      window.require([VIMEO_SDK_URL], (player) => {
        window.Vimeo = { Player: player };
        this.setState({ vimeoLoaded: true });
      });
    }
    if (this.props.autoPlay) {
      this.handleAutoPlay();
    }
  }
  render() {
    if (!this.state.vimeoLoaded && this.isVimeoAndRequireJS()) {
      return null;
    }
    const {
      isPlayable,
      styles,
      disabled,
      onReady,
      onDuration,
      onProgress,
      url,
      width,
      height,
      progressInterval,
      config,
      muted,
      isLoaded,
      controls,
      className,
      onContextMenu,
      loop
    } = this.props;
    return (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      /* @__PURE__ */ React.createElement(
        "div",
        {
          tabIndex: 0,
          onClick: this.onWrapperClick,
          onKeyDown: (e) => {
            if (e.key === "Enter") {
              this.onWrapperClick();
            }
          },
          "data-hook": "reactPlayerWrapper"
        },
        /* @__PURE__ */ React.createElement(
          ReactPlayer,
          {
            playing: this.state.isPlaying && !disabled,
            onPlay: this.handlePlay,
            onPause: this.handlePause,
            controls,
            style: styles,
            light: !isPlayable,
            onReady,
            url,
            width,
            height,
            onDuration,
            onProgress,
            progressInterval,
            config,
            muted,
            "data-loaded": isLoaded,
            className,
            onContextMenu,
            ref: this.playerRef,
            loop
          }
        )
      )
    );
  }
}
ReactPlayerWrapper.propTypes = {
  url: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  isPlayable: PropTypes.bool,
  styles: PropTypes.object,
  onReady: PropTypes.func,
  onDuration: PropTypes.func,
  onProgress: PropTypes.func,
  progressInterval: PropTypes.number,
  config: PropTypes.object,
  width: PropTypes.String,
  height: PropTypes.String,
  muted: PropTypes.bool,
  isLoaded: PropTypes.bool,
  controls: PropTypes.bool,
  loop: PropTypes.bool,
  autoPlay: PropTypes.bool,
  isCustomVideo: PropTypes.bool,
  className: PropTypes.string,
  onContextMenu: PropTypes.func
};
ReactPlayerWrapper.defaultProps = {
  isPlayable: true
};
function isVimeoUrl(url) {
  const MATCH_URL = /vimeo\.com\/.+/;
  const MATCH_FILE_URL = /vimeo\.com\/external\/[0-9]+\..+/;
  return !MATCH_FILE_URL.test(url) && MATCH_URL.test(url);
}

var __defProp$1 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class VideoViewer extends Component {
  constructor(props) {
    super(props);
    this.getUrl = async () => {
      var _a;
      const { src } = this.props.componentData.video || {};
      let url;
      if (src == null ? void 0 : src.url) {
        url = src.url;
      } else if (src == null ? void 0 : src.id) {
        url = await ((_a = this.props.settings) == null ? void 0 : _a.getVideoUrl({ pathname: src.id }));
      }
      return this.normalizeUrl(url);
    };
    this.normalizeUrl = (url) => url && (url.toLowerCase().indexOf("vimeo") === 0 ? "https://" + url : url);
    //vimeo player needs urls prefixed with http[s]
    this.findFormalVideoRatio = (ratio) => {
      const baseRatios = [1, 5 / 4, 4 / 3, 3 / 2, 16 / 10, 16 / 9, 1.85, 2, 2.35, 2.39, 3];
      const videoRatios = [...baseRatios, ...baseRatios.map((x) => 1 / x)];
      const findClosest = (arr, target) => arr.reduce((prev, curr) => Math.abs(curr - target) < Math.abs(prev - target) ? curr : prev);
      const closest = findClosest(videoRatios, ratio);
      return Math.abs(closest - ratio) > 0.01 ? ratio : closest;
    };
    this.onReactPlayerReady = (player) => {
      var _a, _b;
      if (!this.props.isLoaded) {
        ((_b = (_a = this.props).onReady) == null ? void 0 : _b.call(_a, player)) || this.setState({ isLoaded: true });
      }
    };
    this.handleContextMenu = (e) => this.props.componentData.disableDownload && e.preventDefault();
    this.disableDownloadProps = () => {
      const { componentData, settings } = this.props;
      const disableProps = {
        config: {
          file: {
            attributes: {
              controlsList: "nodownload"
            }
          }
        }
      };
      let disable = {};
      if (componentData.disableDownload !== void 0) {
        disable = componentData.disableDownload ? disableProps : {};
      } else if (settings.disableDownload !== void 0) {
        disable = settings.disableDownload ? disableProps : {};
      }
      return disable;
    };
    this.onProgress = (progress) => {
      var _a;
      const { settings, nodeId } = this.props;
      (_a = settings.onProgress) == null ? void 0 : _a.call(settings, __spreadProps(__spreadValues$1({}, progress), { id: nodeId }));
    };
    this.state = { isLoaded: false, isVideoWrapperAttachedToDom: false };
    const { src } = props.componentData.video || {};
    if (src == null ? void 0 : src.url) {
      this.state = __spreadProps(__spreadValues$1({}, this.state), { url: this.normalizeUrl(src.url) });
    } else if (src == null ? void 0 : src.id) {
      const normalizedUrl = props.settings.getVideoUrl({ pathname: src.id });
      typeof normalizedUrl.then === "function" ? normalizedUrl.then((url) => this.setState({ url: this.normalizeUrl(url) })) : this.state = __spreadProps(__spreadValues$1({}, this.state), { url: this.normalizeUrl(normalizedUrl) });
    }
  }
  componentDidMount() {
    this.setState({ key: "mounted" });
  }
  componentDidUpdate() {
    const { isVideoWrapperAttachedToDom } = this.state;
    if (!isVideoWrapperAttachedToDom) {
      const videoRatio = this.getVideoRatio();
      if (videoRatio) {
        this.setVideoRatio(videoRatio.ratio, videoRatio.wrapper);
        this.setState({ isVideoWrapperAttachedToDom: true });
      }
    }
  }
  getVideoRatio() {
    var _a;
    const wrapper = (_a = ReactDOM.findDOMNode(this)) == null ? void 0 : _a.parentNode;
    if (!wrapper) {
      return void 0;
    }
    const element = wrapper.querySelector("iframe, video");
    if (!element) {
      return void 0;
    }
    const ratio = element.clientHeight / element.clientWidth;
    return !isNaN(ratio) ? { ratio, wrapper } : void 0;
  }
  setVideoRatio(ratio, wrapper) {
    wrapper.style["padding-bottom"] = ratio * 100 + "%";
  }
  render() {
    var _a, _b;
    const { disabled, onDuration, settings, muted, componentData, seoMode } = this.props;
    const { key, url } = this.state;
    this.getUrl().then((newUrl) => url !== newUrl && this.setState({ url: newUrl }));
    const isLoaded = this.props.isLoaded || this.state.isLoaded;
    const isCustomVideo = (_b = (_a = componentData.video) == null ? void 0 : _a.src) == null ? void 0 : _b.id;
    const shouldRenderIframe = isSSR() && seoMode && url;
    const {
      autoPlay = false,
      playInLoop = false,
      showControls = true
    } = componentData.options || {};
    const props = __spreadValues$1({
      url,
      onReady: this.onReactPlayerReady,
      disabled,
      width: "100%",
      height: "100%",
      key,
      onDuration,
      onProgress: this.onProgress,
      progressInterval: settings.progressInterval || 1e3,
      muted: muted || autoPlay,
      isLoaded,
      autoPlay,
      loop: playInLoop,
      isCustomVideo
    }, this.disableDownloadProps());
    return shouldRenderIframe ? /* @__PURE__ */ React.createElement(IframePlayer, { isCustomVideo, url }) : /* @__PURE__ */ React.createElement(
      ReactPlayerWrapper,
      __spreadValues$1({
        className: styles.video_player,
        onContextMenu: this.handleContextMenu,
        controls: this.props.isLoaded !== false && showControls
      }, props)
    );
  }
}

const Video = ({ node, nodeIndex, NodeViewContainer }) => {
  const { seoMode, config } = useContext(RicosViewerContext);
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { node, nodeIndex, key: node.id }, /* @__PURE__ */ React.createElement("div", { className: styles.video_container }, /* @__PURE__ */ React.createElement(
    VideoViewer,
    {
      settings: config[VIDEO_TYPE] || {},
      componentData: node.videoData,
      nodeId: node.id,
      seoMode: !!seoMode
    }
  )));
};

const nodeViewRenderers = {
  [Node_Type$1.VIDEO]: Video
};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginVideo = (config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS.configViewer), config),
    type: VIDEO_TYPE,
    nodeViewRenderers
  };
};

export { VIDEO_TYPE, pluginVideo };
//# sourceMappingURL=viewer.js.map

import 'wix-rich-content-plugin-video/dist/es/styles.viewer.min.global.css'